import './login.css';
import { Link, Navigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { defineEmpresa, login } from '../../service/login';
import { useDispatch } from 'react-redux';
import { addTokenEmpresa } from '../../features/token/tokenSlice';
import { useStoreContext } from '../../hooks/context/StoreContext';
import { addUsuario } from '../../features/usuario/usuarioSlice';
import { atrasarFocoInput } from '../../func/focarInput';
import { retirarMascaraCnpj } from '../../func/retirarMascara';
import { formatarCnpj } from '../../func/regex';
import { deletarSessao, verificarSessao } from '../../service/sessao';
import { logout } from '../../features/auth/logoutSlice';
import Logo from '../../images/logo.png';
import FormLogin from '../../components/formTemplate/FormLogin';
import InputTextLogin from '../../components/inputField/InputTextLogin';
import ButtonLogin from '../../components/buttonTemplate/ButtonLogin';
import Footer from '../../components/footer/Footer';
import ModalInformation from '../../components/modais/ModalInformation';
import Animations from '../../components/animation/Animation';
import SpinBtn from '../../components/animation/SpinBtn';
import ReactFocusLock from 'react-focus-lock';
import { deletarTokenNoBack } from '../../service/logout';


const Login = () => {
    const dispatch = useDispatch();

    const refCnpj = useRef();
    const refUsuario = useRef();
    const refSenha = useRef();

    const {
        modal,
        setModal
    } = useStoreContext();

    const [validarFormulario, setValidarFormulario] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [apiCarregando, setApiCarregando] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cnpj, setCnpj] = useState('');
    const [cnpjFormatado, setCnpjFormatado] = useState(false);
    const [habilitarCampo, setHabilitarCampo] = useState({
        cnpj: true,
        usuario: true,
        senha: true
    });
    const [credencial, setCredencial] = useState({
        cnpj: localStorage.getItem('cnpj'),
        login: '',
        senha: ''
    });

    const handleInputCnpj = (e) => {
        if (cnpjFormatado) {
            setCnpj(e.target.value)

            return;
        };

        setCnpj(formatarCnpj(e.target.value))
    };

    async function handleCnpj() {
        setApiCarregando(true);

        try {
            localStorage.clear();
            sessionStorage.clear();
            deletarSessao();

            const response = await defineEmpresa(retirarMascaraCnpj(cnpj));

            if (response.status === 200) {
                localStorage.setItem('cnpj', retirarMascaraCnpj(cnpj));
                setValidarFormulario(true);
            };
        } catch (error) {
            const data = error.response.data;
            const message = 'CNPJ não encontrado!';

            if (data.error === 'Pesquisa não retornou dados.') {
                return setModal(prevModal => ({
                    ...prevModal,
                    openModalInformacao: true,
                    iconeModalInformacao: 'warning',
                    tituloModalInformacao: 'Atenção!',
                    textoModalInformacao: message

                }));
            };

        } finally {
            setApiCarregando(false);
        };
    };

    async function handleLogin() {
        setLoading(true);

        try {
            const response = await login(credencial);
            const data = response.data;

            if (data?.token) {
                localStorage.setItem('token', data.token,);
                localStorage.setItem('codigoUsuario', data.USER.CODIGOUSUARIO);
                dispatch(addTokenEmpresa(data.token));
                dispatch(addUsuario(data.USER))
            };

            if (response.status === 200) {
                setRedirect(true);
            };

        } catch (error) {
            const data = error.response.data;

            setModal(prevModal => ({
                ...prevModal,
                openModalInformacao: true,
                iconeModalInformacao: 'warning',
                tituloModalInformacao: 'Atenção!',
                textoModalInformacao: data.error
            }));
        } finally {
            setLoading(false);
        };
    };

    const handleKeyDownCnpj = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleCnpj();

            setHabilitarCampo(prevHabilitar => ({
                ...prevHabilitar,
                usuario: false
            }));
        };

        if (event.key === 'Backspace') {
            setCnpjFormatado(true);
        } else {
            setCnpjFormatado(false);
        };
    };

    const handleKeyDownLogin = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleLogin();
        };
    };

    const handleHabilitarCampo = (e) => {
        const campo = e.target.name;

        setHabilitarCampo(prevHabilitar => ({
            ...prevHabilitar,
            [campo]: false
        }));
    };

    const handleDesabilitarCampo = (e) => {
        const campo = e.target.name;

        setHabilitarCampo(prevHabilitar => ({
            ...prevHabilitar,
            [campo]: true
        }));
    };

    const handleCnpjNovamente = async () => {
        setValidarFormulario();

        try {
            const token = localStorage.getItem('token');

            if (!token) { return };

            const response = await verificarSessao();

            if (response.data.sessaoAtiva) {
                localStorage.clear();
                sessionStorage.clear();
                dispatch(logout());
                deletarSessao();
                deletarTokenNoBack();
            } else if (!response.data.sessaoAtiva && cnpj) {
                localStorage.clear();
                sessionStorage.clear();
                dispatch(logout());
            };
        } catch (error) {
            console.clear();
        };
    };

    useEffect(() => {
        if (!validarFormulario) {
            atrasarFocoInput(refCnpj, 'focus', 0);
        } else {
            atrasarFocoInput(refUsuario, 'focus', 0);
        };
    }, [validarFormulario]);

    useEffect(() => {
        const verificar = async () => {
            try {
                const response = await verificarSessao();

                if (response.data.sessaoAtiva) {
                    setValidarFormulario(true);
                    localStorage.setItem('cnpj', response.data.cnpj)
                } else if (!response.data.sessaoAtiva) {
                    localStorage.clear();
                    sessionStorage.clear();
                    setValidarFormulario(false);
                };
            } catch (error) {
                console.clear();
            };
        };

        verificar();
    }, []);

    useEffect(() => {
        if (validarFormulario) {
            const cnpj = localStorage.getItem('cnpj');

            if (cnpj) {
                setCredencial(prev => ({
                    ...prev,
                    cnpj: cnpj
                }));
            };

            document.activeElement?.blur();

            setTimeout(() => {
                if (refUsuario.current) {
                    refUsuario.current.disabled = true;
                    refUsuario.current.disabled = false;
                    refUsuario.current.focus();
                }
            }, 100);
        }
    }, [validarFormulario]);

    if (redirect) {
        return <Navigate to="/modulos" replace />;
    };

    return (
        <ReactFocusLock>
            <section
                className='container-login'
                style={{
                    height: '94vh'
                }}
            >
                <div className='container-login-logo'>
                    <img src={Logo} alt='Logo OG1' title='Logo OG1' />
                    <p>Bem vindo ao OG1 WEB!</p>
                    <p>Realize seu login.</p>
                </div>
                {!validarFormulario ? (
                    <FormLogin legenda={'Configuração de Conexão:'}>
                        <InputTextLogin
                            ref={refCnpj}
                            readOnly={habilitarCampo.cnpj}
                            autoComplete={'off'}
                            titulo={'CNPJ'}
                            name={'cnpj'}
                            tipo={'text'}
                            valor={cnpj}
                            onChange={e => handleInputCnpj(e)}
                            onKeyDown={handleKeyDownCnpj}
                            onFocus={handleHabilitarCampo}
                            onBlur={handleDesabilitarCampo}
                            maxLength={'18'}
                        />
                        <ButtonLogin click={handleCnpj}>
                            Conectar
                        </ButtonLogin>
                    </FormLogin>
                ) : (
                    <FormLogin>
                        <InputTextLogin
                            ref={refUsuario}
                            readOnly={habilitarCampo.usuario}
                            autoComplete={'off'}
                            titulo={'Usuário'}
                            name={'usuario'}
                            tipo={'text'}
                            valor={credencial.login}
                            onChange={e => setCredencial(credencial => ({ ...credencial, login: e.target.value }))}
                            onKeyDown={handleKeyDownLogin}
                            onFocus={handleHabilitarCampo}
                            onBlur={handleDesabilitarCampo}
                        />
                        <InputTextLogin
                            ref={refSenha}
                            readOnly={habilitarCampo.senha}
                            autoComplete={'off'}
                            titulo={'Senha'}
                            name={'senha'}
                            tipo={'password'}
                            valor={credencial.senha}
                            onChange={e => setCredencial(credencial => ({ ...credencial, senha: e.target.value }))}
                            onKeyDown={handleKeyDownLogin}
                            onFocus={handleHabilitarCampo}
                            onBlur={handleDesabilitarCampo}
                        />
                        <ButtonLogin click={handleLogin}>
                            {loading ?
                                <SpinBtn />
                                :
                                'Entrar'
                            }
                        </ButtonLogin>
                        <Link className='btn-return' onClick={handleCnpjNovamente}>
                            Inserir CNPJ novamente
                        </Link>
                    </FormLogin>
                )}
                {apiCarregando && <Animations />}
            </section>
            <Footer />
            <ModalInformation
                isOpen={modal.openModalInformacao}
                closeModal={() => setModal(prevModal => ({
                    ...prevModal,
                    openModalInformacao: false
                })
                )}
                icone={modal.iconeModalInformacao}
                titulo={modal.tituloModalInformacao}
                texto={modal.textoModalInformacao}
            />
        </ReactFocusLock>
    );
};

export default Login;
